import { Box, Card, CardContent, Button, CardMedia, IconButton, Typography, Menu, MenuItem, Select } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Styles from '../Config/Styles'
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ModalBox from './Modal';
import { storage } from '../Config/Storage';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { AddRFQ, deleteOrder, deleteRFQ, getdraftOrders, getOrdersDetail, updateOrder, updateRfq } from '../Redux/Mycart/action';
import ButtonBox from './Button';
import { useDispatch, useSelector } from 'react-redux';
import Loader from './Loader';
import { useLocation, useNavigate } from 'react-router-dom';
import { INFO, LOGIN, ORDERS, PROFILE, RFQ } from '../Routes/constURL';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import SelectBox from './SelectBox';
import Input from './Input';
import { productDetails } from '../Redux/Products/action';
const MyCart = ({ orders, cart }) => {
    const { ordersDetails } = useSelector((state) => state?.CartData) || [];
    const { productDetail } = useSelector((state) => state?.ProductsData) || [];
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [file, setFile] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [value, setValue] = useState(0)
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedValues1, setSelectedValues1] = useState(null);
    const [openEdit, setOpenEdit] = useState(false)
    const [index, setIndex] = useState()
    const [Orderlist, setOrderList] = useState([])
    const rfq = storage.fetch.rfq()
    const [unit, setUnit] = useState();

    const handleOpen = () => {
        setOpen(true)
    }

    useEffect(() => {
        setOrderList(orders)
        setValue(ordersDetails?.quantity)
        setSelectedValues1(ordersDetails?.details)
        setUnit(ordersDetails?.unit)
    }, [orders, productDetail, ordersDetails])


    const handleClose = () => {
        setOpen(false)
    }

    const handleFileDrop = (event) => {
        event.preventDefault();
        const uploadedFile = event.dataTransfer.files[0];
        setFile(uploadedFile);
    };

    const handleFileInput = (event) => {
        const uploadedFile = event.target.files[0];
        setFile(uploadedFile);


    };
    const handleDelete = () => {
        setLoading(true)
        setFile(null);
        storage.destory.rfq()
        const id = storage.fetch.rfqID()
        if (id)
            dispatch(deleteRFQ({ id }, setLoading))
    };
    const handleSubmit = () => {
        setLoading(true)
        const formData = new FormData()
        formData.append('folder', '808aa655-2821-4911-a9db-f7353dd95f72');
        formData.append('file', file);
        dispatch(AddRFQ(formData, handleClose, setLoading))
    }
    const handleRequest = () => {
        setLoading(true)
        const loggedIn = storage.fetch.phone()
        if (loggedIn === undefined) {
            navigate(LOGIN)
        } else {
            if (Orderlist.length) {
                Orderlist?.map((item) => {
                    const data = {
                        user_id: loggedIn,
                        id: item.id,
                    }
                    dispatch(updateOrder(data, "", setLoading))
                })
                setTimeout(() => {
                    navigate(ORDERS)
                }, 2000);
            }

            if (rfq) {
                const data = {
                    Status: "published", user_id: loggedIn
                }
                dispatch(updateRfq(data, setLoading))
                setTimeout(() => {
                    navigate(RFQ)
                }, 2000);

            }


        }
    }
    const handleDropdownOpen = (event, item, i) => {

        setOpenEdit(false); // Open the edit section
        setIndex(i); // Set the index of the clicked product
        setAnchorEl(event.currentTarget);
        setSelectedItem(item); // Track which item is selected
    };

    const handleDropdownClose = () => {
        setAnchorEl(null);
    };

    const handleEdit = () => {
        setLoading(true)
        dispatch(productDetails({ id: selectedItem.product }, setLoading)); // Fetch product details using the ID
        dispatch(getOrdersDetail({ id: selectedItem.id }, setLoading)); // Fetch product details using the ID
        setOpenEdit(true); // Open the edit section
        handleDropdownClose(); // Close the dropdown menu
    };

    const handleDeleteItem = () => {
        setLoading(true)
        dispatch(deleteOrder({ id: selectedItem.id }, "", setLoading))
        setOrderList([])
        handleDropdownClose();
    };
    const handleSave = () => {
        const data = {
            id: selectedItem.id,
            quantity: value,
            unit: unit
        }
        setLoading(true)
        setOrderList([])
        setOpenEdit(false)
        dispatch(updateOrder(data, selectedValues1, setLoading))
    }


    return (
        <Box sx={cart ? Styles.cart().box : { ...Styles.middleBoxStyle().box, p: 0, alignItems: "start" }}>
            <Loader open={loading} />
            <Typography
                variant="h5"
                sx={Styles.cart(Orderlist).typo}
            >
                {rfq && Orderlist?.length ? "My RFQ Request" : rfq ? "My RFQ Request" : "My Cart"}
            </Typography>
            <ModalBox open={open} handleClose={handleClose} handleDelete={handleDelete} handleSubmit={handleSubmit} handleFileInput={handleFileInput} handleFileDrop={handleFileDrop} file={file} setFile={setFile} />
            {!Orderlist?.length && rfq === undefined ? <>
                <img src={require('../assets/mycart.png')} width={"200px"} />
                <Typography sx={Styles.cart().noprod}>No Products Added</Typography>
                <Typography sx={Styles.cart().desc}>Start browsing our building material, add the required item(s) to your cart and submit your RFQ</Typography>
                <Typography sx={Styles.cart().sep}>OR</Typography>
                <Button sx={Styles.cart().rfqbtn} onClick={handleOpen}>  <AttachFileIcon sx={Styles.cart().icon} />
                    <Typography sx={Styles.cart().btn}>Attach your RFQ Document</Typography>
                    <input type="file" hidden /></Button>
            </> :
                <Card className="box" sx={Styles.cart("", rfq).card}>
                    {rfq === undefined ?
                        <>
                            <Box
                                sx={Styles.cart().imgbox}
                            >
                                <img src={require('../assets/Group.png')} width={"30px"} style={{ margin: 2 }} />
                                {rfq === undefined && <Typography variant="body2" sx={Styles.cart().delbox}>Delivered Within 3-4 Days</Typography>}
                            </Box>
                            {Orderlist?.map((item, ind) =>
                                <Box>
                                    <Box
                                        key={ind}
                                        sx={Styles.cart().listbox}
                                    >
                                        <CardMedia
                                            component="img"
                                            image={item?.order_image ? `https://api-dev.tabta.net/assets/${item?.order_image}?cache-buster=2025-01-02T11:33:33.214Z&key=system-large-contain` : require('../assets/dummy.jpg')}
                                            alt="Product"
                                            sx={Styles.cart().media}
                                        />

                                        <CardContent sx={Styles.cart().content}>
                                            <Typography variant="subtitle1" sx={Styles.cart().cardtypo} >
                                                {item?.product_name}
                                            </Typography>
                                            <Box sx={Styles.cart().descbox}>
                                                {item && item.details?.map((val, index) =>

                                                    <Typography variant="body2" sx={Styles.cart().desctypo}>
                                                        {val?.attribute_value}{"| "}
                                                    </Typography>
                                                )}
                                                <Typography variant="body2" sx={Styles.cart().desctypo}>{item?.quantity}{item?.unit}</Typography>

                                            </Box>
                                        </CardContent>
                                        <Box sx={Styles.cart().iconbox}>

                                            <IconButton sx={{ zIndex: 9999999 }} onClick={(event) => handleDropdownOpen(event, item, ind)}>
                                                <MoreVertOutlinedIcon />

                                            </IconButton>
                                        </Box>
                                        <Menu
                                            anchorEl={anchorEl}
                                            open={Boolean(anchorEl)}
                                            onClose={handleDropdownClose}
                                            sx={{ "&.MuiModal-root ": { zIndex: 99999999999999 } }}
                                        >
                                            <MenuItem onClick={() => handleEdit()}>Edit</MenuItem>
                                            <MenuItem onClick={handleDeleteItem}>Delete</MenuItem>
                                        </Menu>

                                    </Box>
                                    {openEdit && index === ind && < Box
                                        sx={Styles.cart().editbox}
                                    >
                                        <SelectBox data={productDetail?.fields} selectedValues1={selectedValues1} setSelectedValues1={setSelectedValues1} />
                                        <Box sx={{ mt: 2 }}>
                                            <Box>
                                                <Typography sx={Styles.cart().qty}>Quantity<span style={{ color: "#FF0202", }}>*</span></Typography>
                                            </Box>
                                            <Box sx={Styles.cart().input}>
                                                <Input quantity={true} type={'text'} value={value} setValue={setValue} />
                                                <Box sx={Styles.productsdetails.unitbox}>
                                                    {productDetail?.units?.length === 1 ?

                                                        <Typography>{unit}</Typography>
                                                        : <Select
                                                            sx={Styles.select.input}
                                                            value={unit}
                                                            onChange={(e) => setUnit(e.target.value)}
                                                        >
                                                            {productDetail?.units?.map((item) =>
                                                                <MenuItem value={item.units_id.name}>
                                                                    {item.units_id.name}
                                                                </MenuItem>
                                                            )}
                                                        </Select>
                                                    }
                                                </Box>

                                            </Box>
                                        </Box>
                                        <Box sx={Styles.cart().btnbox}>
                                            <ButtonBox text={"Cancel"} color={"transparent"} textcolor={"black"} onClick={() => setOpenEdit(false)} />
                                            <ButtonBox text={"Save Edit"} color={"black"} onClick={handleSave} />
                                        </Box>
                                    </Box>
                                    }
                                </Box>
                            )}
                        </>
                        : <Box sx={{ width: "100%" }}>
                            <Typography sx={Styles.cart().attachtypo}>Attachment</Typography>
                            <Box sx={Styles.cart().attachbox}>
                                <Typography>{rfq}</Typography>
                                <IconButton onClick={handleDelete}><DeleteOutlineOutlinedIcon sx={{ color: "red" }} /></IconButton>
                            </Box>

                        </Box>}
                    <Box sx={{ p: rfq ? 0 : 2 }}>
                        <ButtonBox color={"black"} text={"Proceed To Request Quotation"} onClick={handleRequest} />
                    </Box>
                </Card>}
        </Box >
    )
}

export default MyCart